import angular from 'angular';

import { fetchOrderStatusesDictionary } from 'app/actions/dictionaries/order-statuses-dictionary.actions';
import { fetchPackStatusesDictionary } from 'app/actions/dictionaries/pack-statuses-dictionary.actions';
import { fetchPricePointsDictionary } from 'app/actions/dictionaries/price-points-dictionary.actions';

import './config/errorcodes.conf';

import { changePageTitle } from 'auth/actions/session.actions';
import packDetailsModule from './components/pack-details/pack-details.module';
import orderDetailsModule from './components/order-details/order-details.module';
import detailsDialogModule from './components/details-dialog/details-dialog.module';
import inventoryHeaderModule from './components/inventory-header/inventory-header-module';
import orderMonthSelectorModule from './components/order-month-selector/order-month-selector-module';
import orderStatusSelectorModule from './components/order-status-selector/order-status-selector-module';

import inventoryTabsModule from './components/inventory-tabs/inventory-tabs-module';
import inventoryTransitionsHistoryChainTabModule from './components/inventory-transitions-history-chain-tab/inventory-transitions-history-chain-tab.module';
import inventoryTransitionsHistoryIndependentTabModule from './components/inventory-transitions-history-independent-tab/inventory-transitions-history-independent-tab.module';
import inventoryOrderHistoryIndependentTabModule from './components/inventory-order-history-independet-tab/inventory-order-history-independet-tab-module';
import inventoryOrderHistoryChainTabModule from './components/inventory-order-history-chain-tab/inventory-order-history-chain-tab-module';
import inventoryGamesTabModule from './components/inventory-games-tab/inventory-games-tab-module';
import inventoryPacksTabModule from './components/inventory-packs-tab/inventory-packs-tab-module';
import inventoryLiabilityTabModule from './components/inventory-liability-tab/inventory-liability-tab-module';

import ManageInventoryTableService from './manage-inventory-table-service';

export default angular
  .module('manage-inventory', [
    'manage-inventory-errorcodes',
    packDetailsModule.name,
    orderDetailsModule.name,
    detailsDialogModule.name,
    inventoryTabsModule.name,
    inventoryHeaderModule.name,
    inventoryPacksTabModule.name,
    inventoryGamesTabModule.name,
    orderMonthSelectorModule.name,
    orderStatusSelectorModule.name,
    inventoryLiabilityTabModule.name,
    inventoryOrderHistoryChainTabModule.name,
    inventoryOrderHistoryIndependentTabModule.name,
    inventoryTransitionsHistoryChainTabModule.name,
    inventoryTransitionsHistoryIndependentTabModule.name,
  ])
  .service('manageInventoryTableService', ManageInventoryTableService)
  .config([
    '$stateProvider',
    function configuration($stateProvider) {
      $stateProvider.state('manageInventory-listByType', {
        parent: 'arw',
        url: '/manage-inventory-list-by-type?tabId&retailerNo',
        reloadOnSearch: false,
        template: '<inventory-tabs></inventory-tabs>',
        redirectTo: 'permissions-denied',
        params: {
          pageTitle: [
            '$ngRedux',
            'gettextCatalog',
            ($ngRedux, gettextCatalog) => {
              $ngRedux.dispatch(changePageTitle(gettextCatalog.getString('View Inventory')));
            },
          ],
        },
        resolve: {
          api: [
            '$ngRedux',
            'appApi',
            ($ngRedux) =>
              Promise.all([
                $ngRedux.dispatch(fetchOrderStatusesDictionary()),
                $ngRedux.dispatch(fetchPackStatusesDictionary()),
                $ngRedux.dispatch(fetchPricePointsDictionary()),
              ]),
          ],
        },
      });
    },
  ]);



// WEBPACK FOOTER //
// ./src/modules/manage-inventory/manage-inventory-component.js